// 正则验证
// 手机号
export const regPhone = str => {
  const reg = /^1[3-9][0-9]{9}$/;
  // 返回true或false
  return reg.test(str);
}


// 弱密码（大于等于六位）
export const regPassOne = str =>{
	// const reg = /^(?![^a-zA-Z]+$)(?!\D+$)/;
	// reg.test(str)
	// 返回true或false
	return str.length>=6 && str.length<=18;
}
// 中密码（6-8位）
/* export const regPassTwo = str =>{
	const reg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,8}$/; 
	// 返回true或false
	return reg.test(str);
} */

// 不限制长度，不允许有任何特殊符号、中文与空格
export const regPassTwo = str =>{
	const reg = /^[a-zA-Z0-9]{6,}$/; 
	// 返回true或false
	return reg.test(str);
}

// /^[a-zA-Z0-9]{6,8}$/ 6-8位
//如果需要必须包含至少一个字母和一个数字的话，/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,18}$/

// 强密码（必须包含大小写字母和数字的组合，不能使用特殊字符，长度在8-10之间）
export const regPassThere = str =>{
	const reg = /^(?=.\d)(?=.[a-z])(?=.*[A-Z]).{8,10}$/;
	
	// 返回true或false
	return reg.test(str)
}



//验证码（等于6位）
export const regYz = str =>{
	// 返回true或false
	return str.length == 6;
}

// 邮箱
export const regEmail = str =>{
	const reg = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
	// 返回true或false
	return reg.test(str)
}

// 昵称长度限制(不超过10位)
export const regName = str =>{
	// 返回true或false
	return str.length < 10
}

// 手机号脱敏
// this.phone.substring(0,3) + '****' + this.phone.substring(7,11)



// WEBPACK FOOTER //
// ./src/assets/js/reg.js